import { FiX } from 'react-icons/fi'
import styled, { ITheme } from '../../../../theme'

const Icon = styled(FiX)`
  font-size: 20px;

  color: ${(props: ITheme) => props.theme.colors.palette.slateGrey};

  &:hover {
    cursor: pointer;
  }
`

export default Icon
